import { makeAutoObservable } from 'mobx';

export default class TagItem {
	static readonly NewTagId = 0;
	updatedName?: string;
	deleted?: boolean;

	constructor(readonly id: number, readonly originalName: string, readonly count: number = 0) {
		makeAutoObservable(this);
	}
}
